import { TimeFormat } from "../types/calendarSettings";

class timestampService {
  static returnTwoDigitTimeString(timeValue: number) {
    if (timeValue < 10) {
      return `0${timeValue}`;
    } else {
      return timeValue.toString();
    }
  }

  static getHoursAndMinutesTimestamp(date: string | Date): string {
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return "";

    const hh = timestampService.returnTwoDigitTimeString(d.getHours());
    const mm = timestampService.returnTwoDigitTimeString(d.getMinutes());
    return `${hh}:${mm}`;
  }

  static getRoundedDate(date: Date) {
    let minutes = date.getMinutes();
    let hours = date.getHours();

    if (minutes < 15) date.setMinutes(0);
    else if (minutes < 45) date.setMinutes(30);
    else {
      date.setMinutes(0);
      date.setHours(hours + 1);
    }

    return date;
  }

  static timeToMinutes(time: TimeFormat | string) {
    if (!time || time === "None") return "00:00";
    return time.slice(0, 5);
  }

  static timeToSeconds(time: string) {
    const newTime = time.trim();
    if (!newTime) return "None";
    return (newTime.length === 5 ? `${newTime}:00` : newTime) as TimeFormat;
  }

  static timeToMinutesSum = (time: string): number => {
    const hhmm = time.includes("T")
      ? timestampService.getHoursAndMinutesTimestamp(time)
      : time;

    const [hours, minutes] = hhmm.split(":").map(Number);
    return hours * 60 + minutes;
  };

  static mergeTimeIntoDate(originalDateTime: string, newTime: string): string {
    if (!originalDateTime || !newTime)
      return originalDateTime;

    const [hours, minutes] = newTime.split(":").map(Number);

    const base = new Date(originalDateTime);
    base.setHours(hours, minutes, 0, 0);
    return base.toISOString();
  }
}

export default timestampService;
